<p-button
  [label]="btnLabel"
  i18n-label="@@sharepoint-button-label"
  [rounded]="true"
  [severity]="'secondary'"
  [icon]="btnIcon"
  [disabled]="processing"
  (onClick)="openFileBrowser()"
  />

<p-dialog
  [header]="isReplaceMode ? 'SharePoint – Dokument ersetzen' : 'SharePoint auswählen'"
  [(visible)]="displayFileBrowser"
  [modal]="true"
  [closable]="true"
  [style]="{width: '60vw', minHeight: '60vh'}"
  i18n-header="@@sharepoint-dialog-header"
  >
  <div class="d-flex gap-2 mb-3">
    <p-button
      [label]="'Dateien'"
      i18n-label="@@sharepoint-tab-files"
      [severity]="activeTab === 0 ? 'primary' : 'secondary'"
      [outlined]="activeTab !== 0"
      (onClick)="onTabChange({ index: 0 })"
      />
    <p-button
      [label]="'SharePoint Pages'"
      i18n-label="@@sharepoint-tab-pages"
      [severity]="activeTab === 1 ? 'primary' : 'secondary'"
      [outlined]="activeTab !== 1"
      (onClick)="onTabChange({ index: 1 })"
      />
  </div>

  @if (activeTab === 0) {
    @if (breadcrumbs.length > 0) {
      <div
        class="breadcrumbs mb-2"
        >
        <div class="breadcrumbs-path">
          @for (crumb of breadcrumbs; track crumb; let i = $index) {
            <span
              class="breadcrumb"
              style="margin-bottom: 0px;"
              (click)="navigateBreadcrumb(i)"
              >
              @if (i === 0) {
                <i
                  class="ri-home-line"
                  aria-label="Home"
                  title="Home"
                  i18n-title="@@breadcrumb-home"
                  i18n-aria-label="@@breadcrumb-home"
                ></i>
              }
              @if (i > 0) {
                {{ crumb.name }}
              }
            </span>
            @if (i < breadcrumbs.length - 1) {
              <span
                class="breadcrumb-separator"
                >
                <i
                  class="ri-arrow-right-s-line"
                  aria-hidden="true"
                ></i>
              </span>
            }
          }
        </div>
        <span class="p-input-icon-left breadcrumbs-search">
          <input
            type="text"
            pInputText
            [(ngModel)]="searchQuery"
            placeholder="Filtern"
            i18n-placeholder="@@sharepoint-search-files"
            class="sp-search-input"
            />
        </span>
      </div>
    }
    @if (loading) {
      <div
        class="sp-loading"
        >
        <p-progressspinner
          [style]="{width: '2.5rem', height: '2.5rem'}"
          strokeWidth="4"
          />
      </div>
    }
    @if (!loading) {
      <ul
        class="sp-items"
        >
        @for (item of filteredItems; track item) {
          <li
            (click)="selectItem(item)"
            [class.folder]="item['isFolder']"
            [class.file]="!item['isFolder']"
            >
            <i
              [class]="getFileIcon(item)"
              aria-hidden="true"
            ></i>
            <span class="sp-item-name">{{ item.name }}</span>
            @if (item['isFolder']) {
              <i
                class="ri-arrow-right-s-line sp-item-chevron"
                aria-hidden="true"
              ></i>
            }
          </li>
        }
        @if (filteredItems.length === 0) {
          <li
            class="sp-empty"
            >
            <i
              class="ri-inbox-line"
              aria-hidden="true"
            ></i>
            <span i18n="@@sharepoint-empty-files">Keine Dateien gefunden</span>
          </li>
        }
      </ul>
    }
  }

  @if (activeTab === 1) {
    <div class="sp-search">
      <span class="p-input-icon-left">
        <input
          type="text"
          pInputText
          [(ngModel)]="pageSearchQuery"
          placeholder="Filtern"
          i18n-placeholder="@@sharepoint-search-pages"
          class="sp-search-input"
          />
      </span>
    </div>
    @if (loading) {
      <div
        class="sp-loading"
        >
        <p-progressspinner
          [style]="{width: '2.5rem', height: '2.5rem'}"
          strokeWidth="4"
          />
      </div>
    }
    @if (!loading) {
      <ul
        class="sp-items"
        >
        @for (page of filteredPages; track page) {
          <li
            (click)="selectPage(page)"
            class="file"
            >
            <i
              class="ri-pages-line"
              aria-hidden="true"
            ></i>
            <span class="sp-item-name">{{ page.title }}</span>
          </li>
        }
        @if (filteredPages.length === 0) {
          <li
            class="sp-empty"
            >
            <i
              class="ri-inbox-line"
              aria-hidden="true"
            ></i>
            <span i18n="@@sharepoint-empty-pages">Keine Seiten gefunden</span>
          </li>
        }
      </ul>
    }
  }
</p-dialog>